import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=02663aed&"
import script from "./Tables.vue?vue&type=script&lang=ts&"
export * from "./Tables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports